import { SchoolInfo } from "../../redux/school/schoolSlice";

import { useState } from "react";
import { ConversationList } from "./ConversationList";
import { ContactAdd } from "./ContactAdd";
import { ClassroomInfo } from "../../redux/classroom/classroomSlice";
import { NamedObject } from "../../redux/object/namedObject";

interface ConvContactListContainerProps {
    school?: SchoolInfo;
    classroom?: ClassroomInfo;
    dpto?: ClassroomInfo;
    height: number;
    me?: NamedObject;
}

type ConversationListContainerOptions = "main" | "add";

export const ConversationListContainer = (props: ConvContactListContainerProps) => {
    const [ contentSelected, setContentSelected ] = useState( "main" as ConversationListContainerOptions );

    if(props.school && props.me && contentSelected == "add") {
        return <ContactAdd
            clickReturn={() => setContentSelected("main")}
            me={props.me}
            school={props.school}
            classroom={props.classroom}
            dpto={props.dpto}
            height={props.height}
        />;
    }

    return <ConversationList 
        clickAddContact={() => setContentSelected("add")}
        // me={props.me}
        school={props.school}
        classroom={props.classroom}
        dpto={props.dpto}
        height={props.height}
    />;

};